import { Toaster } from '~/components/Toast';
import { ErrorBoundary } from '~/modules/errors/components/ErrorBoundary';

import { Router } from './router';

export function App() {
  return (
    <ErrorBoundary key="my-profile">
      <Toaster offset="1rem" />
      <Router />
    </ErrorBoundary>
  );
}

App.displayName = 'ProfileApp';
